import React, { useState, useEffect } from 'react'
import { useRef } from "react";
import { Link } from 'react-router-dom'
import Slider from "react-slick";
import { BaseUrl, getAssetUrl } from "../../helper/BaseUrl";
import axios from "axios";

const truncateText = (htmlString, maxLength) => {
    if (!htmlString || typeof htmlString !== "string") return "";
    const plainText = htmlString.replace(/<\/?[^>]+(>|$)/g, "");
    return plainText.length > maxLength ? plainText.substring(0, maxLength) + "..." : plainText;
};

export default function HomeWork({ ctaText, ctaLink, onCtaClick, initialData}) {
    const sliderRef = useRef(null);

    const finalCtaText = ctaText || "Learn More";
    const finalCtaLink = ctaLink || "/services/";

    const ButtonContent = (
    <>
        <span className="text">{finalCtaText}</span>
        <div className="icon-container">
        <div className="icon icon--left">
            <i className="fa-solid fa-arrow-right"></i>
        </div>
        <div className="icon icon--right">
            <i className="fa-solid fa-arrow-right"></i>
        </div>
        </div>
    </>
    );


    const [howWork, sethowWork] = useState(initialData || []);
    const dataFetcher = async () => {
        try {
            const response = await axios.get(`${BaseUrl}/api/how-we-works`);
            sethowWork(response.data?.how_we_works);
        } catch (error) {
            console.error("Data fetch error:", error);
            throw error;
        }
    };

    useEffect(() => {
        dataFetcher();
    }, [])

    if (!howWork) {
        return null;
    }


    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 4,
        autoplaySpeed: 3000,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: false,
        cssEase: "ease",
        draggable: false,
        swipe: false,
        responsive: [
            {
            breakpoint: 991,
            settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true, },
            },
            {
                breakpoint: 767,
                settings: { slidesToShow: 2, draggable: true, swipe: true, autoplay: true, },
            },
            {
                breakpoint: 599,
                settings: { slidesToShow: 1, draggable: true, swipe: true, autoplay: true, },
            },
        ],
    };

    const CustomArrows = () => (
        <>
        <div className="default-arrow default-mobilearrow" onClick={() => sliderRef.current.slickPrev()}>
            <i className="fa-solid fa-arrow-left"></i>
        </div>
        <div className="default-arrow default-mobilearrow default-arrowright" onClick={() => sliderRef.current.slickNext()}>
            <i className="fa-solid fa-arrow-right"></i>
        </div>
        </>
    );

  return (
    <>
    <section className="howwork-head">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <h3 className="heading">How we work</h3>
                </div>
            </div>
        </div>
    </section>

    <section className="howwork-area">
        <div className="container">
            <div className="row justify-content-end">
                <div className="col-lg-6 col-md-6">
                    <p className="howwork-para">Curating timeless interiors that reflect your unique essence, where sophistication meets soulful design, crafted with purpose, precision, and enduring elegance.</p>
                </div>

                <div className="col-lg-12">
                    <div className="howwork-slider">
                        <Slider {...settings} ref={sliderRef}>
                            {howWork.slice(0,4).map((data,index)=>( 
                            <div className="howwork-slidebox" key={index}>
                                <img src={getAssetUrl(data?.icon)} alt={data?.title} loading="lazy"/>
                                <label>{data?.title}</label>
                                <p>{truncateText(data.description)}</p>
                                <span>{String.fromCharCode(65 + index)}</span>
                            </div>
                            ))}
                        </Slider>
                        <CustomArrows />
                    </div>

                    <div className="text-center">
                        {onCtaClick ? (
                        <button type="button" onClick={onCtaClick} className="default-butn">{ButtonContent}</button>
                        ) : (
                        <Link to={finalCtaLink} className="default-butn">{ButtonContent}</Link>
                        )}
                    </div>
                    
                </div>
            </div>
        </div>
    </section> 
    </>
  )
}
